import gameNames from '../../hub/data/GameIds';

const initialState = { alexState: 0 };

const alexReducer = (state = initialState, action) => {
  if (action.gameId !== gameNames.SUPER_MATCH) {
    return state;
  }

  switch (action.type) {
    case 'SET_ALEX_INACTIVE':
      return { ...state, alexState: 0 };
    case 'SET_ALEX_ACTIVE':
      return { ...state, alexState: 1 };
    case 'SET_ALEX_SPEAKING':
      return { ...state, alexState: 2 };
    default:
      return state;
  }
};

export default alexReducer;
